import { useState, useEffect, useCallback } from "react";
import api from "api";
import { GB_IN_BYTES } from "../utils/fileValidation";

export function useUsageInfo(token) {
  const [data, setData] = useState({
    maxStorageInBytes: 0,
    usedStorageInBytes: 0,
    maxProjects: 0,
    currentProjects: 0,
    isLoading: true,
    error: null
  });

  const fetchUsageData = useCallback(async () => {
    if (!token) {
      setData(prev => ({ ...prev, isLoading: false }));
      return;
    }

    setData(prev => ({ ...prev, isLoading: true, error: null }));

    try {
      const [userPlanResponse, azureUsageResponse] = await Promise.all([
        api.get("/plans/user", {
          headers: { Authorization: `Bearer ${token}` }
        }),
        api.get("/plans/usage", {
          headers: { Authorization: `Bearer ${token}` }
        })
      ]);

      const planData = userPlanResponse.data[0];
      const cloudUsageData = azureUsageResponse.data;

      const projectCount = cloudUsageData.project_stats
        ? Object.values(cloudUsageData.project_stats).reduce(
            (sum, stats) => sum + (stats.subfolders || 0),
            0
          )
        : 0;

      setData({
        maxStorageInBytes: (planData.storage || 0) * GB_IN_BYTES,
        usedStorageInBytes: (cloudUsageData.total_size || 0) * GB_IN_BYTES,
        maxProjects: planData.max_projects || 0,
        currentProjects: projectCount,
        isLoading: false,
        error: null
      });
    } catch (err) {
      console.error("Error fetching usage data:", err);
      setData(prev => ({
        ...prev,
        isLoading: false,
        error: "Não foi possível carregar os dados de uso do plano."
      }));
    }
  }, [token]);

  useEffect(() => {
    fetchUsageData();
  }, [fetchUsageData]);

  const incrementProjectCount = () => {
    setData(prev => ({
      ...prev,
      currentProjects: (prev.currentProjects || 0) + 1
    }));
  };

  return { ...data, incrementProjectCount, refetchUsageInfo: fetchUsageData };
}
